import { Component, Input, OnInit } from '@angular/core';
import { EnvironmentService } from '../services/environment.service';
import { AnonymousPortalSettingsService } from 'projects/borrower-app/src/app/services/anonymous-portal-settings.service';
import { legalDocumentsPageHref } from 'projects/borrower-app/src/app/services/legal-documents';
import { NavigationService } from 'projects/borrower-app/src/app/services/navigation.service';

@Component({
    selector: 'footer',
    templateUrl: 'footer.component.html',
    standalone: false,
    styles: [`
      .footer-disclosure-content { font-size: .8rem; line-height: 1.4; }
      .footer-disclosure-content ::ng-deep img { max-height: 40px; width: auto; vertical-align: middle; }
    `]
})

export class FooterComponent implements OnInit {

  @Input()
  isDefaultFlow: boolean = false;

  @Input()
  industryAffiliations: string[] = [];

  currentYear: number = new Date().getFullYear();

  version: string = '';

  readonly footerDisclosureHtml$ = this._anonymousPortalSettings.footerDisclosureHtml$;

  // LLS-886 §4: the page with the lender's (EN/ES) Privacy Policy and Terms of Use, not Lodasoft's English site.
  get legalDocumentsHref(): string {
    return legalDocumentsPageHref(this._navigationService.companyGuid);
  }

  constructor(
    private readonly _environmentService: EnvironmentService,
    private readonly _anonymousPortalSettings: AnonymousPortalSettingsService,
    private readonly _navigationService: NavigationService,
  ) { }

  ngOnInit() {
    this.version = this._environmentService.version;
  }
}
